import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg
    width={props.width}
    style={props.style}
    height={props.width}
    viewBox="0 -30 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${props.className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="m496.136719 291.480469-151-242c-19.332031-30.984375-52.65625-49.480469-89.136719-49.480469l-60 226 60 226h151c57.898438 0 105-47.101562 105-105 0-19.6875-5.484375-38.886719-15.863281-55.519531zm0 0"/>
    <path d="m166.863281 49.480469-151 242c-10.378906 16.632812-15.863281 35.832031-15.863281 55.519531 0 57.898438 47.101562 105 105 105h151v-452c-36.480469 0-69.804688 18.496094-89.136719 49.480469zm0 0" fill="#292c32"/>
    <path d="m445.234375 323.242188-151-241.996094c-8.300781-13.304688-22.59375-21.246094-38.234375-21.246094l-75 166 75 166h151c24.8125 0 45-20.1875 45-45 0-8.566406-2.277344-16.558594-6.765625-23.757812zm0 0" fill="#ffa433"/>
    <path d="m217.765625 81.242188-150.996094 242c-4.492187 7.195312-6.769531 15.191406-6.769531 23.757812 0 24.8125 20.1875 45 45 45h151v-332c-15.640625 0-29.933594 7.941406-38.234375 21.242188zm0 0" fill="#ffc43b"/>
    <path d="m271 165h-15l-10 53 10 53h15zm0 0"/>
    <path d="m241 165h15v106h-15zm0 0" fill="#292c32"/>
    <path d="m271 301h-15l-10 15 10 15h15zm0 0"/>
    <path d="m241 301h15v30h-15zm0 0" fill="#292c32"/>
  </svg>  
);

export default Icon;
